import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AirportRegisterPage } from './airport-register.page';

const routes: Routes = [
  {
    path: '',
    component: AirportRegisterPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AirportRegisterPageRoutingModule {}
